import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../api";
import type { ReviewState } from "./types";

export const reviewKeys = {
  current: ["review"] as const,
};

export function useReview() {
  return useQuery<ReviewState>({ queryKey: reviewKeys.current, queryFn: api.review });
}

export function useStartReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (space?: string | null) => api.startReview(space),
    onSuccess: (state) => {
      qc.setQueryData(reviewKeys.current, state);
      // Otwarcie przeglądu to wiadomość w chacie - odśwież historię.
      void qc.invalidateQueries({ queryKey: ["chat", "messages"] });
    },
  });
}

export function useAbandonReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.abandonReview(),
    onSuccess: (state) => qc.setQueryData(reviewKeys.current, state),
  });
}
